import * as moment from "moment";
import JobBDPChangeNotificationData from "./JobBDPChangeNotificationData";
import NotificationBase from "../../NotificationBase";
import {JobBDPChangeNotificationDataApiDto, NotificationBaseApiDto} from "../../../../api/model/rest";
import {getUser} from "../../../../store/view/user";

/**
 * Job BDP changed notification.
 */
export default class JobBDPChangeNotification extends NotificationBase {
	/**
	 * @param {string} id Notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read Flag if note is marked as read.
	 * @param {"JOB_BUSINESS_DEVELOPMENT_PARTNER_ASSIGNED"} type Note type, in this case always 'NOTE_REMINDER'.
	 * @param {JobBDPChangeNotificationData} data Note notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: JobBDPChangeNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): JobBDPChangeNotification {
		return new JobBDPChangeNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			JobBDPChangeNotificationData.fromJson(json.data as JobBDPChangeNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 */
	displayCreatorName(): string {
		return getUser(this.data.entity.id).map(u => u.getDisplayName()).getOrElse(this.data.entity.id);
	}

	/**
	 * Display previous bdp full name
	 */
	displayPreviousAssignee(): string {
		return this.data.previousBusinessDevelopmentPartnerId
			.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("Unassigned"))
			.getOrElse("Unassigned");
	}

	/**
	 * Display current bdp full name
	 */
	displayCurrentAssignee(): string {
		return this.data.currentBusinessDevelopmentPartnerId
			.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("Unassigned"))
			.getOrElse("Unassigned");
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new JobBDPChangeNotification(id, dateTime, read, type, data);
	}
}